<div style="margin-top:1%">
  <h4 class="text-center">SETTLEMENT CLASS MEMBER ELECTION FORM</h4>
</div>




<div class="row mt-4">
  <div class="col-md-12">
    <form [formGroup]="electionForm" (ngSubmit)="onSubmit()" autocomplete="off" novalidate #formRef="ngForm">

      <div class="row rowformat mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="fullName"><b>Full Name:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="fullName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.fullName.errors }" />
            <div *ngIf="submitted && f.fullName.errors" class="invalid-feedback">
              <div *ngIf="f.fullName.errors.required">This field is required</div>
              <div *ngIf="f.fullName.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.fullName.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.fullName.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-12">
          <div class="form-group">
            <label for="street1"><b>Mailing Address (Street, PO Box, Suite, or Office Number):</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="street1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
            <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
              <div *ngIf="f.street1.errors.required">This field is required</div>
              <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.street1.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row rowformat">
        <div class="col-md-4">
          <div class="form-group">
            <label for="city"><b>City:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
            <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
              <div *ngIf="f.city.errors.required">This field is required</div>
              <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
              <div *ngIf="f.city.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="state"><b>State:</b><span style="color:red" class="required"> *</span></label>
            <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
              <option value="">Please Select A State</option>
              <option *ngFor="let allstate of allStates">
                {{allstate.Name}}
              </option>
            </select>
            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
              <div *ngIf="f.state.errors.required">This field is required</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="zip"><b>Zip Code:</b><span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
            <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
              <div *ngIf="f.zip.errors.required">This field is required</div>
              <div *ngIf="f.zip.errors.pattern">
                US zip Code with format 99999 or 99999-9999 alone are accepted
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row lightgraybackground">
        <div class="col-md-12 text-center">
          Additional Information
        </div>
      </div>
      <div class="row rowformat mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="noticeId"><b>Notice ID:<span style="color:red" class="required"> *</span></b></label>
            <input type="text" class="form-control" formControlName="noticeId" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.noticeId.errors }" />
            <div *ngIf="submitted && f.noticeId.errors" class="invalid-feedback">
              <div *ngIf="f.noticeId.errors.required">This field is required</div>
              <div *ngIf="f.noticeId.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.noticeId.errors.maxlength">
                This field must not be at greater 10 digits
              </div>
              <div *ngIf="f.noticeId.errors.pattern">This field accepts only numerical digits 0-9</div>
            </div>
          </div>
          * Your Notice ID was on the notice of the Settlement you received by postal mail.  If you do not have your Notice ID, call or email the Settlement Administrator
          for assistance at 1-877-719-6771 or <a href="mailto:info@ONTrailsSettlement.com">info@ONTrailssSettlement.com.</a>
        </div>
      </div>

      <div class="row rowformat mt-4">
        <div class="col-md-6">
          <div class="form-group">
            <label for="emailAddress"><b>Email Address:</b></label>
            <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.emailAddress.errors }" />
            <div *ngIf="submitted && f.emailAddress.errors" class="invalid-feedback">
              <div *ngIf="f.emailAddress.errors.maxlength">This field must not be at greater 255 characters</div>
              <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="phone1"><b>Telephone Number:</b></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="phone1" placeholder="" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phone1.errors }" />
            <div *ngIf="submitted && f.phone1.errors" class="invalid-feedback">
              <!--<div *ngIf="f.phone1.errors.required">This field is required</div>-->
              <div *ngIf="f.phone1.errors.minlength">This field must be at least 10 digits</div>
              <div *ngIf="f.phone1.errors.maxlength">This field must not be at greater 10 digits</div>
              <div *ngIf="f.phone1.errors.pattern">Only use numbers</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          Please make your payment selection below by checking the box for ONE Settlement Benefit option:
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <input type="radio" id="Digital Payment" formControlName="paymentType" value="Digital Payment">&nbsp;
          <label for="Digital Payment"> <b>I request to have my Settlement Benefit be in the form of a digital payment such as Venmo or PayPal.</b></label>

          <br />
          <input type="radio" id="Check" formControlName="paymentType" value="Check">&nbsp;
          <label for="Check"> <b>I request to have my Settlement Benefit in the form of a check.</b> </label>


          <!--<div *ngIf="submitted && f.paymentForm.errors" class="custom-error">
            <div *ngIf="f.paymentForm.errors.required">This field is required</div>
          </div>-->
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label for="signature"><b>Electronic Signature:</b> <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
            <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
              <div *ngIf="f.signature.errors.required">This field is required</div>
              <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
              <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
              <div *ngIf="f.signature.errors.pattern">
                Only use letters, numbers, periods, spaces, hyphens,
                brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" ngDefaultControl [ngClass]="{ 'is-invalid': submitted && f.googleRecaptchaToken.errors }"></re-captcha>
            <div *ngIf="submitted && f.googleRecaptchaToken.errors">
              <div *ngIf="f.googleRecaptchaToken.errors.required" class="custom-error">This field is required</div>
            </div>
          </div>
        </div>
      </div>
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>
    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>
